import type { AppEnv } from '../config/env'

/**
 * Ошибки приложения в Sentry (FE-ADR-023): проект dorixona-client на
 * sentry.udevs.io. Без DSN ничего не грузим — так работают стенд, разработка
 * и тесты. SDK приходит отдельным чанком и не задерживает первый экран; ошибки
 * до его загрузки не ловятся. Отвечает, подключён ли Sentry.
 */
export async function startSentry(
  config: Pick<AppEnv, 'sentryDsn' | 'environment'>,
  load = () => import('./sentryClient'),
): Promise<boolean> {
  if (!config.sentryDsn) return false
  const { initSentry } = await load()
  initSentry(config.sentryDsn, config.environment)
  return true
}
